import { useQuery } from '@rocicorp/zero/react'

import { queries } from '#zero/queries.ts'
import { workspaceMembersFromZero } from '#zero/workspace-members-from-zero.ts'

export function useWorkspaceMembers(workspaceId: string) {
  const [members] = useQuery(queries.workspaceMembers.members({ workspaceId }))
  const [invitations] = useQuery(
    queries.workspaceMembers.invitations({ workspaceId }),
  )

  return workspaceMembersFromZero(members, invitations)
}
